import { useEffect, useState } from 'react'

interface UseCycledPlaceholderProps {
  placeholders: string[]
  interval?: number
}

export const useCycledPlaceholder = ({
  placeholders,
  interval = 20000,
}: UseCycledPlaceholderProps) => {
  const [index, setIndex] = useState<number>(
    Math.floor(Math.random() * placeholders.length),
  )

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % placeholders.length)
    }, interval)
    return () => clearInterval(intervalId)
  }, [interval, placeholders.length])

  return {
    placeholder: placeholders[index],
    index,
  }
}
